import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, } from "@mui/material";
import { COLORS } from "../../../../ui/Theme";
import NotFound from "../../../../components/notfound/NotFound";
import IncrementRow from "./IncrementRow";
import DecrementRow from "./DecrementRow";

const DomesticTable = ({ incData, decData }) => {
    const cols = Object.values({
        symbol: "نماد",
        commodity: "کالا",
        deviation: "تغییر قیمت",
        last_price_date: "تاریخ آخرین قیمت",
    });

    return (
        <TableContainer sx={{ overflow: "auto" }}>
            <Table size="small" sx={{ tableLayout: "auto", whiteSpace: "nowrap" }}>
                <TableHead>
                    <TableRow>
                        {cols.map((col) => (
                            <TableCell
                                key={col}
                                sx={{
                                    fontWeight: 700,
                                    textAlign: "center",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                {col}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody >
                    <TableRow sx={{ bgcolor: COLORS.SOFTGREEN }}>
                        <TableCell
                            colSpan={4}
                            sx={{
                                textAlign: "center",
                                color: COLORS.GREEN,
                            }}
                        >
                            بیشترین افزایش ماهانه
                        </TableCell>
                    </TableRow>
                    {incData.length < 1 ? (
                        <TableRow >
                            <TableCell colSpan={4} sx={{ textAlign: "center" }}>
                                <Box sx={{ height: 145 }}>
                                    <NotFound />
                                </Box>
                            </TableCell>
                        </TableRow>
                    ) : (
                        incData.map((row, index) => <IncrementRow key={index} row={row} />)
                    )}

                    <TableRow sx={{ bgcolor: COLORS.SOFTRED }}>
                        <TableCell
                            colSpan={4}
                            sx={{
                                textAlign: "center",
                                color: COLORS.RED,
                            }}
                        >
                            بیشترین کاهش ماهانه
                        </TableCell>
                    </TableRow>
                    {decData.length < 1 ? (
                        <TableRow >
                            <TableCell colSpan={4} sx={{ textAlign: "center" }}>
                                <Box sx={{ height: 145 }}>
                                    <NotFound />
                                </Box>
                            </TableCell>
                        </TableRow>
                    ) : (
                        decData.map((row, index) => <DecrementRow key={index} row={row} />)
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default DomesticTable;
